var currurl = $(location).attr('href');
var page = currurl.substring(currurl.lastIndexOf('/') + 1);

// Opening all links in new tab in Essential Oil Guide

$(".tabcontent a:not(.back_to_guide a), .shopify-section--custom-liquid .blog-list a, .shopify-section--custom-liquid .grid-wrapper .article_content a, .article__wrapper a, .image-with-text.image-with-text--reverse a:not([href='#']), #shopify-section-template--16926071947492__main a, #shopify-section-template--19410688540900__logo_list_4tcNeW a").each(function(){
    //event.preventDefault();
    var url = $(this).attr("href");
    $(this).attr("onclick", "window.open('"+url+"','_blank');return false");
});

// Popup message for Blogs right Panel - Add to Cart

$(".blog_right_add_button").on('click', function(event){
    $("<p class='blog_success_message'>The product is added to cart</p>").insertAfter( $(this));
    
    //fade out in 15 seconds if not closed 
    $(".blog_success_message").delay(5000).fadeOut("slow");
});

// Add to cart button for the home page

$(".home_add_button").on('click', function(event){
    $("cart-drawer").attr("style","display:block");
    $("cart-drawer").attr("open","");
    $("cart-drawer").addClass("drawer");
    document.querySelector('cart-drawer').shadowRoot.querySelector('div>div:first-child').setAttribute('style', 'opacity:1');
    document.querySelector('cart-drawer').shadowRoot.querySelector('div>div:nth-child(2)').style.transform="translateX(0px)";
    document.querySelector('cart-drawer').shadowRoot.querySelector('div>div:nth-child(2)').setAttribute('style', 'margin-inline-start:auto');
});
//console.log(page);
// Script to hide header on quick-links page

if (page == 'quick-links') {
    $('h1').hide();
}

// Removing link functionality from empty URLs

$("a[href='#']").css('cursor', 'default');
//$(".image-with-text.image-with-text--reverse .metafield-rich_text_field p>a[href='#']").on('click', function(event){
$("a[href='#']").on('click', function(event){
  event.preventDefault();
});

var resizeTimer;
$(window).resize(function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        if ($(window).width() <= 800) {
          $("slideshow-carousel picture>img").attr({"width": "800"});
        }
    },250);
});                 

// Script for Gifts tab change page

if(window.location.href.indexOf("/pages/gifts-by-occasion") > -1){
  const hash = location.hash;
  var catid = hash.slice(1, hash.length);
  var i, tabcontent;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
  if (!catid) {
    const caturl = document.getElementById('defaultOpen').getAttribute("href");
    catid = caturl.slice(1, caturl.length);
  } 
  // console.log(catid);
  document.getElementById(catid).style.display = "block";
}

// Script for Defaulting the lazy loading to eager on first banner image

// Get the first image element
const firstHomeImage = document.querySelector('slideshow-carousel picture img');

// Change the loading attribute of the first image
if(firstHomeImage){
    firstHomeImage.loading = 'eager';
  }

// Get the first image element
const firstImage = document.querySelector('.article__image img');

// Change the loading attribute of the first image
if(firstImage){
    firstImage.loading = 'eager';
  }

// Get the first image element
const firstImageCollection = document.querySelector('.collection-banner img');

// Change the loading attribute of the first image
if(firstImageCollection){
    firstImageCollection.loading = 'eager';
  }

// Change the loading attribute of the logo
const logoImage = document.querySelector('.header__logo img');
logoImage.loading = 'eager';

// Script to change the text for Safety points

if(page.includes('guide-to-')){
  $("h3.avoid").html("Good to know / Safety");
}

if(page.includes('pet-')){
  $(".image-with-text.image-with-text--reverse .h3").hide();
  $(".image-with-text.image-with-text--reverse .pets_knowmore_icon .h3").show();
  //$(".pets_knowmore_icon").css("display", "block");
}else{
  //console.log("else");
  $(".image-with-text.image-with-text--reverse .h3").show();
  $(".image-with-text.image-with-text--reverse .pets_knowmore_icon .h3").hide();
}


// $("#shopify-section-sections--18102412017892__countdown_condensed_WneJMY").hide();
// if(page=='incense-sticks')
// {
//   $("#shopify-section-sections--18102412017892__countdown_condensed_WneJMY").show();
// }


// Script included for diffusers bundle offer to hide Hot deals section on product page for all elec diffusers

// const diff_ary = ["essential-oil-diffuser-for-large-spaces-mahan", "essential-oil-diffuser-for-home-or-office-shanthi", "usb-car-diffuser-manam","portable-aromatherapy-diffuser-yatra","portable-500ml-essential-oil-diffuser-sutra","multipurpose-essential-oil-diffuser-with-light-tejas","essential-oil-diffuser-with-flame-light-agni","usb-car-humidifier-ardra"];

// if(diff_ary.includes(page)){  
//   $('.product-info__block-item[data-block-id=liquid_GxCPct]').remove();
//   $('.product-info__block-item[data-block-id=offers_Y6iNNy]').remove();
// }
